import { defineNuxtPlugin } from '#app'
import { useAnalyticsStore } from '~/store/analytics/analytics'

export default defineNuxtPlugin({
  async setup() {
    const { getAnalyticsCityForCommonPage } = useAnalyticsStore()

    await getAnalyticsCityForCommonPage()
  },
})
